import React from 'react';
import { ShieldCheck } from 'lucide-react';

type Props = {
  trustScore: number;
  verificationDate: string;
  size?: 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
};

export default function ShieldBadge({ trustScore, verificationDate, size = 'md', showTooltip = true }: Props) {
  const sizeMap = {
    sm: { icon: 14, text: 'text-xs', px: 'px-2 py-0.5', gap: 'gap-1' },
    md: { icon: 16, text: 'text-xs', px: 'px-2.5 py-1', gap: 'gap-1.5' },
    lg: { icon: 20, text: 'text-sm', px: 'px-3 py-1.5', gap: 'gap-2' },
  };
  const s = sizeMap[size];

  return (
    <div className="relative group inline-flex">
      <div
        className={`badge-verified text-white rounded-full flex items-center ${s.gap} ${s.px} shadow-shield`}
        role="img"
        aria-label="Verified Authentic Store"
      >
        <ShieldCheck size={s.icon} className="flex-shrink-0 shield-pulse" />
        <span className={`font-semibold ${s.text} whitespace-nowrap`}>Verified Authentic</span>
      </div>
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 bg-foreground text-background text-xs rounded-lg p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 shadow-lg">
          <p className="font-semibold mb-1">Make me Authentic Verified ✓</p>
          <p className="text-background/80 mb-1">Trust Score: {trustScore}/100</p>
          <p className="text-background/80">Verified on: {verificationDate}</p>
          <p className="text-background/60 mt-1 text-xs">All authenticity parameters checked by Make me Authentic team.</p>
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-foreground" />
        </div>
      )}
    </div>
  );
}